import { default as _91signatureRequestKey_93WOzR6ibEzbMeta } from "/runner/_work/nova-widget/nova-widget/domains/core/pages/[signatureRequestKind]/[signatureRequestKey].vue?macro=true";
import { default as feedbackH8V96qnFBpMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/feedback.vue?macro=true";
import { default as finishAvH0H7wUJwMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/finish.vue?macro=true";
import { default as goneNGaK0QJWJLMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/gone.vue?macro=true";
import { default as address_45proofTKy5HbozVVMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/address-proof.vue?macro=true";
import { default as biometricPbWssqRRsnMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/biometric.vue?macro=true";
import { default as digital_45certificateSvrismDTm3Meta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/digital-certificate.vue?macro=true";
import { default as documentscopyM4jA99t3nKMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/documentscopy.vue?macro=true";
import { default as facial_45biometricsjmsZdtzTUZMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/facial-biometrics.vue?macro=true";
import { default as handwrittenmCtvPb5KjfMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/handwritten.vue?macro=true";
import { default as informationrqAudPo1XGMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/information.vue?macro=true";
import { default as livenessWXWhlNCVDbMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/liveness.vue?macro=true";
import { default as official_45doc9yKt4M9RYJMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/official-doc.vue?macro=true";
import { default as pixUMG7I0U3cFMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/pix.vue?macro=true";
import { default as selfie_45plus_45docf9bVDxjvBeMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/selfie-plus-doc.vue?macro=true";
import { default as summaryJv1qNkv7nAMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/summary.vue?macro=true";
import { default as _91tokenKind_93UF12bZifcIMeta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/token/[tokenKind].vue?macro=true";
import { default as requirementVXfrWJ59k6Meta } from "/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement.vue?macro=true";
import { default as agreementsaN6rRVESCiMeta } from "/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/agreements.vue?macro=true";
import { default as indexgycyvmJmtYMeta } from "/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/index.vue?macro=true";
import { default as indexSEnKvuPz4GMeta } from "/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/index.vue?macro=true";
export default [
  {
    name: _91signatureRequestKey_93WOzR6ibEzbMeta?.name ?? "signatureRequestKind-signatureRequestKey___pt-BR___default",
    path: _91signatureRequestKey_93WOzR6ibEzbMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()",
    meta: _91signatureRequestKey_93WOzR6ibEzbMeta || {},
    alias: _91signatureRequestKey_93WOzR6ibEzbMeta?.alias || [],
    redirect: _91signatureRequestKey_93WOzR6ibEzbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/core/pages/[signatureRequestKind]/[signatureRequestKey].vue").then(m => m.default || m)
  },
  {
    name: _91signatureRequestKey_93WOzR6ibEzbMeta?.name ?? "signatureRequestKind-signatureRequestKey___pt-BR",
    path: _91signatureRequestKey_93WOzR6ibEzbMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()",
    meta: _91signatureRequestKey_93WOzR6ibEzbMeta || {},
    alias: _91signatureRequestKey_93WOzR6ibEzbMeta?.alias || [],
    redirect: _91signatureRequestKey_93WOzR6ibEzbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/core/pages/[signatureRequestKind]/[signatureRequestKey].vue").then(m => m.default || m)
  },
  {
    name: _91signatureRequestKey_93WOzR6ibEzbMeta?.name ?? "signatureRequestKind-signatureRequestKey___en-US",
    path: _91signatureRequestKey_93WOzR6ibEzbMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()",
    meta: _91signatureRequestKey_93WOzR6ibEzbMeta || {},
    alias: _91signatureRequestKey_93WOzR6ibEzbMeta?.alias || [],
    redirect: _91signatureRequestKey_93WOzR6ibEzbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/core/pages/[signatureRequestKind]/[signatureRequestKey].vue").then(m => m.default || m)
  },
  {
    name: _91signatureRequestKey_93WOzR6ibEzbMeta?.name ?? "signatureRequestKind-signatureRequestKey___es-MX",
    path: _91signatureRequestKey_93WOzR6ibEzbMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()",
    meta: _91signatureRequestKey_93WOzR6ibEzbMeta || {},
    alias: _91signatureRequestKey_93WOzR6ibEzbMeta?.alias || [],
    redirect: _91signatureRequestKey_93WOzR6ibEzbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/core/pages/[signatureRequestKind]/[signatureRequestKey].vue").then(m => m.default || m)
  },
  {
    name: feedbackH8V96qnFBpMeta?.name ?? "signatureRequestKind-signatureRequestKey-feedback___pt-BR___default",
    path: feedbackH8V96qnFBpMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/feedback",
    meta: feedbackH8V96qnFBpMeta || {},
    alias: feedbackH8V96qnFBpMeta?.alias || [],
    redirect: feedbackH8V96qnFBpMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackH8V96qnFBpMeta?.name ?? "signatureRequestKind-signatureRequestKey-feedback___pt-BR",
    path: feedbackH8V96qnFBpMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/feedback",
    meta: feedbackH8V96qnFBpMeta || {},
    alias: feedbackH8V96qnFBpMeta?.alias || [],
    redirect: feedbackH8V96qnFBpMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackH8V96qnFBpMeta?.name ?? "signatureRequestKind-signatureRequestKey-feedback___en-US",
    path: feedbackH8V96qnFBpMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/feedback",
    meta: feedbackH8V96qnFBpMeta || {},
    alias: feedbackH8V96qnFBpMeta?.alias || [],
    redirect: feedbackH8V96qnFBpMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/feedback.vue").then(m => m.default || m)
  },
  {
    name: feedbackH8V96qnFBpMeta?.name ?? "signatureRequestKind-signatureRequestKey-feedback___es-MX",
    path: feedbackH8V96qnFBpMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/feedback",
    meta: feedbackH8V96qnFBpMeta || {},
    alias: feedbackH8V96qnFBpMeta?.alias || [],
    redirect: feedbackH8V96qnFBpMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/feedback.vue").then(m => m.default || m)
  },
  {
    name: finishAvH0H7wUJwMeta?.name ?? "signatureRequestKind-signatureRequestKey-finish___pt-BR___default",
    path: finishAvH0H7wUJwMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/finish",
    meta: finishAvH0H7wUJwMeta || {},
    alias: finishAvH0H7wUJwMeta?.alias || [],
    redirect: finishAvH0H7wUJwMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/finish.vue").then(m => m.default || m)
  },
  {
    name: finishAvH0H7wUJwMeta?.name ?? "signatureRequestKind-signatureRequestKey-finish___pt-BR",
    path: finishAvH0H7wUJwMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/finish",
    meta: finishAvH0H7wUJwMeta || {},
    alias: finishAvH0H7wUJwMeta?.alias || [],
    redirect: finishAvH0H7wUJwMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/finish.vue").then(m => m.default || m)
  },
  {
    name: finishAvH0H7wUJwMeta?.name ?? "signatureRequestKind-signatureRequestKey-finish___en-US",
    path: finishAvH0H7wUJwMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/finish",
    meta: finishAvH0H7wUJwMeta || {},
    alias: finishAvH0H7wUJwMeta?.alias || [],
    redirect: finishAvH0H7wUJwMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/finish.vue").then(m => m.default || m)
  },
  {
    name: finishAvH0H7wUJwMeta?.name ?? "signatureRequestKind-signatureRequestKey-finish___es-MX",
    path: finishAvH0H7wUJwMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/finish",
    meta: finishAvH0H7wUJwMeta || {},
    alias: finishAvH0H7wUJwMeta?.alias || [],
    redirect: finishAvH0H7wUJwMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/finish.vue").then(m => m.default || m)
  },
  {
    name: goneNGaK0QJWJLMeta?.name ?? "signatureRequestKind-signatureRequestKey-gone___pt-BR___default",
    path: goneNGaK0QJWJLMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/gone",
    meta: goneNGaK0QJWJLMeta || {},
    alias: goneNGaK0QJWJLMeta?.alias || [],
    redirect: goneNGaK0QJWJLMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/gone.vue").then(m => m.default || m)
  },
  {
    name: goneNGaK0QJWJLMeta?.name ?? "signatureRequestKind-signatureRequestKey-gone___pt-BR",
    path: goneNGaK0QJWJLMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/gone",
    meta: goneNGaK0QJWJLMeta || {},
    alias: goneNGaK0QJWJLMeta?.alias || [],
    redirect: goneNGaK0QJWJLMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/gone.vue").then(m => m.default || m)
  },
  {
    name: goneNGaK0QJWJLMeta?.name ?? "signatureRequestKind-signatureRequestKey-gone___en-US",
    path: goneNGaK0QJWJLMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/gone",
    meta: goneNGaK0QJWJLMeta || {},
    alias: goneNGaK0QJWJLMeta?.alias || [],
    redirect: goneNGaK0QJWJLMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/gone.vue").then(m => m.default || m)
  },
  {
    name: goneNGaK0QJWJLMeta?.name ?? "signatureRequestKind-signatureRequestKey-gone___es-MX",
    path: goneNGaK0QJWJLMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/gone",
    meta: goneNGaK0QJWJLMeta || {},
    alias: goneNGaK0QJWJLMeta?.alias || [],
    redirect: goneNGaK0QJWJLMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/gone.vue").then(m => m.default || m)
  },
  {
    name: requirementVXfrWJ59k6Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement___pt-BR___default",
    path: requirementVXfrWJ59k6Meta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/requirement",
    children: [
  {
    name: address_45proofTKy5HbozVVMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-address-proof___pt-BR___default",
    path: address_45proofTKy5HbozVVMeta?.path ?? "address-proof",
    meta: address_45proofTKy5HbozVVMeta || {},
    alias: address_45proofTKy5HbozVVMeta?.alias || [],
    redirect: address_45proofTKy5HbozVVMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/address-proof.vue").then(m => m.default || m)
  },
  {
    name: biometricPbWssqRRsnMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-biometric___pt-BR___default",
    path: biometricPbWssqRRsnMeta?.path ?? "biometric",
    meta: biometricPbWssqRRsnMeta || {},
    alias: biometricPbWssqRRsnMeta?.alias || [],
    redirect: biometricPbWssqRRsnMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/biometric.vue").then(m => m.default || m)
  },
  {
    name: digital_45certificateSvrismDTm3Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-digital-certificate___pt-BR___default",
    path: digital_45certificateSvrismDTm3Meta?.path ?? "digital-certificate",
    meta: digital_45certificateSvrismDTm3Meta || {},
    alias: digital_45certificateSvrismDTm3Meta?.alias || [],
    redirect: digital_45certificateSvrismDTm3Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/digital-certificate.vue").then(m => m.default || m)
  },
  {
    name: documentscopyM4jA99t3nKMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-documentscopy___pt-BR___default",
    path: documentscopyM4jA99t3nKMeta?.path ?? "documentscopy",
    meta: documentscopyM4jA99t3nKMeta || {},
    alias: documentscopyM4jA99t3nKMeta?.alias || [],
    redirect: documentscopyM4jA99t3nKMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/documentscopy.vue").then(m => m.default || m)
  },
  {
    name: facial_45biometricsjmsZdtzTUZMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-facial-biometrics___pt-BR___default",
    path: facial_45biometricsjmsZdtzTUZMeta?.path ?? "facial-biometrics",
    meta: facial_45biometricsjmsZdtzTUZMeta || {},
    alias: facial_45biometricsjmsZdtzTUZMeta?.alias || [],
    redirect: facial_45biometricsjmsZdtzTUZMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/facial-biometrics.vue").then(m => m.default || m)
  },
  {
    name: handwrittenmCtvPb5KjfMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-handwritten___pt-BR___default",
    path: handwrittenmCtvPb5KjfMeta?.path ?? "handwritten",
    meta: handwrittenmCtvPb5KjfMeta || {},
    alias: handwrittenmCtvPb5KjfMeta?.alias || [],
    redirect: handwrittenmCtvPb5KjfMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/handwritten.vue").then(m => m.default || m)
  },
  {
    name: informationrqAudPo1XGMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-information___pt-BR___default",
    path: informationrqAudPo1XGMeta?.path ?? "information",
    meta: informationrqAudPo1XGMeta || {},
    alias: informationrqAudPo1XGMeta?.alias || [],
    redirect: informationrqAudPo1XGMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/information.vue").then(m => m.default || m)
  },
  {
    name: livenessWXWhlNCVDbMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-liveness___pt-BR___default",
    path: livenessWXWhlNCVDbMeta?.path ?? "liveness",
    meta: livenessWXWhlNCVDbMeta || {},
    alias: livenessWXWhlNCVDbMeta?.alias || [],
    redirect: livenessWXWhlNCVDbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/liveness.vue").then(m => m.default || m)
  },
  {
    name: official_45doc9yKt4M9RYJMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-official-doc___pt-BR___default",
    path: official_45doc9yKt4M9RYJMeta?.path ?? "official-doc",
    meta: official_45doc9yKt4M9RYJMeta || {},
    alias: official_45doc9yKt4M9RYJMeta?.alias || [],
    redirect: official_45doc9yKt4M9RYJMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/official-doc.vue").then(m => m.default || m)
  },
  {
    name: pixUMG7I0U3cFMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-pix___pt-BR___default",
    path: pixUMG7I0U3cFMeta?.path ?? "pix",
    meta: pixUMG7I0U3cFMeta || {},
    alias: pixUMG7I0U3cFMeta?.alias || [],
    redirect: pixUMG7I0U3cFMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/pix.vue").then(m => m.default || m)
  },
  {
    name: selfie_45plus_45docf9bVDxjvBeMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-selfie-plus-doc___pt-BR___default",
    path: selfie_45plus_45docf9bVDxjvBeMeta?.path ?? "selfie-plus-doc",
    meta: selfie_45plus_45docf9bVDxjvBeMeta || {},
    alias: selfie_45plus_45docf9bVDxjvBeMeta?.alias || [],
    redirect: selfie_45plus_45docf9bVDxjvBeMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/selfie-plus-doc.vue").then(m => m.default || m)
  },
  {
    name: summaryJv1qNkv7nAMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-summary___pt-BR___default",
    path: summaryJv1qNkv7nAMeta?.path ?? "summary",
    meta: summaryJv1qNkv7nAMeta || {},
    alias: summaryJv1qNkv7nAMeta?.alias || [],
    redirect: summaryJv1qNkv7nAMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/summary.vue").then(m => m.default || m)
  },
  {
    name: _91tokenKind_93UF12bZifcIMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-token-tokenKind___pt-BR___default",
    path: _91tokenKind_93UF12bZifcIMeta?.path ?? "token/:tokenKind()",
    meta: _91tokenKind_93UF12bZifcIMeta || {},
    alias: _91tokenKind_93UF12bZifcIMeta?.alias || [],
    redirect: _91tokenKind_93UF12bZifcIMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/token/[tokenKind].vue").then(m => m.default || m)
  }
],
    meta: requirementVXfrWJ59k6Meta || {},
    alias: requirementVXfrWJ59k6Meta?.alias || [],
    redirect: requirementVXfrWJ59k6Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement.vue").then(m => m.default || m)
  },
  {
    name: requirementVXfrWJ59k6Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement___pt-BR",
    path: requirementVXfrWJ59k6Meta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/requirement",
    children: [
  {
    name: address_45proofTKy5HbozVVMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-address-proof___pt-BR",
    path: address_45proofTKy5HbozVVMeta?.path ?? "address-proof",
    meta: address_45proofTKy5HbozVVMeta || {},
    alias: address_45proofTKy5HbozVVMeta?.alias || [],
    redirect: address_45proofTKy5HbozVVMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/address-proof.vue").then(m => m.default || m)
  },
  {
    name: biometricPbWssqRRsnMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-biometric___pt-BR",
    path: biometricPbWssqRRsnMeta?.path ?? "biometric",
    meta: biometricPbWssqRRsnMeta || {},
    alias: biometricPbWssqRRsnMeta?.alias || [],
    redirect: biometricPbWssqRRsnMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/biometric.vue").then(m => m.default || m)
  },
  {
    name: digital_45certificateSvrismDTm3Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-digital-certificate___pt-BR",
    path: digital_45certificateSvrismDTm3Meta?.path ?? "digital-certificate",
    meta: digital_45certificateSvrismDTm3Meta || {},
    alias: digital_45certificateSvrismDTm3Meta?.alias || [],
    redirect: digital_45certificateSvrismDTm3Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/digital-certificate.vue").then(m => m.default || m)
  },
  {
    name: documentscopyM4jA99t3nKMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-documentscopy___pt-BR",
    path: documentscopyM4jA99t3nKMeta?.path ?? "documentscopy",
    meta: documentscopyM4jA99t3nKMeta || {},
    alias: documentscopyM4jA99t3nKMeta?.alias || [],
    redirect: documentscopyM4jA99t3nKMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/documentscopy.vue").then(m => m.default || m)
  },
  {
    name: facial_45biometricsjmsZdtzTUZMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-facial-biometrics___pt-BR",
    path: facial_45biometricsjmsZdtzTUZMeta?.path ?? "facial-biometrics",
    meta: facial_45biometricsjmsZdtzTUZMeta || {},
    alias: facial_45biometricsjmsZdtzTUZMeta?.alias || [],
    redirect: facial_45biometricsjmsZdtzTUZMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/facial-biometrics.vue").then(m => m.default || m)
  },
  {
    name: handwrittenmCtvPb5KjfMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-handwritten___pt-BR",
    path: handwrittenmCtvPb5KjfMeta?.path ?? "handwritten",
    meta: handwrittenmCtvPb5KjfMeta || {},
    alias: handwrittenmCtvPb5KjfMeta?.alias || [],
    redirect: handwrittenmCtvPb5KjfMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/handwritten.vue").then(m => m.default || m)
  },
  {
    name: informationrqAudPo1XGMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-information___pt-BR",
    path: informationrqAudPo1XGMeta?.path ?? "information",
    meta: informationrqAudPo1XGMeta || {},
    alias: informationrqAudPo1XGMeta?.alias || [],
    redirect: informationrqAudPo1XGMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/information.vue").then(m => m.default || m)
  },
  {
    name: livenessWXWhlNCVDbMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-liveness___pt-BR",
    path: livenessWXWhlNCVDbMeta?.path ?? "liveness",
    meta: livenessWXWhlNCVDbMeta || {},
    alias: livenessWXWhlNCVDbMeta?.alias || [],
    redirect: livenessWXWhlNCVDbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/liveness.vue").then(m => m.default || m)
  },
  {
    name: official_45doc9yKt4M9RYJMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-official-doc___pt-BR",
    path: official_45doc9yKt4M9RYJMeta?.path ?? "official-doc",
    meta: official_45doc9yKt4M9RYJMeta || {},
    alias: official_45doc9yKt4M9RYJMeta?.alias || [],
    redirect: official_45doc9yKt4M9RYJMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/official-doc.vue").then(m => m.default || m)
  },
  {
    name: pixUMG7I0U3cFMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-pix___pt-BR",
    path: pixUMG7I0U3cFMeta?.path ?? "pix",
    meta: pixUMG7I0U3cFMeta || {},
    alias: pixUMG7I0U3cFMeta?.alias || [],
    redirect: pixUMG7I0U3cFMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/pix.vue").then(m => m.default || m)
  },
  {
    name: selfie_45plus_45docf9bVDxjvBeMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-selfie-plus-doc___pt-BR",
    path: selfie_45plus_45docf9bVDxjvBeMeta?.path ?? "selfie-plus-doc",
    meta: selfie_45plus_45docf9bVDxjvBeMeta || {},
    alias: selfie_45plus_45docf9bVDxjvBeMeta?.alias || [],
    redirect: selfie_45plus_45docf9bVDxjvBeMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/selfie-plus-doc.vue").then(m => m.default || m)
  },
  {
    name: summaryJv1qNkv7nAMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-summary___pt-BR",
    path: summaryJv1qNkv7nAMeta?.path ?? "summary",
    meta: summaryJv1qNkv7nAMeta || {},
    alias: summaryJv1qNkv7nAMeta?.alias || [],
    redirect: summaryJv1qNkv7nAMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/summary.vue").then(m => m.default || m)
  },
  {
    name: _91tokenKind_93UF12bZifcIMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-token-tokenKind___pt-BR",
    path: _91tokenKind_93UF12bZifcIMeta?.path ?? "token/:tokenKind()",
    meta: _91tokenKind_93UF12bZifcIMeta || {},
    alias: _91tokenKind_93UF12bZifcIMeta?.alias || [],
    redirect: _91tokenKind_93UF12bZifcIMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/token/[tokenKind].vue").then(m => m.default || m)
  }
],
    meta: requirementVXfrWJ59k6Meta || {},
    alias: requirementVXfrWJ59k6Meta?.alias || [],
    redirect: requirementVXfrWJ59k6Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement.vue").then(m => m.default || m)
  },
  {
    name: requirementVXfrWJ59k6Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement___en-US",
    path: requirementVXfrWJ59k6Meta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/requirement",
    children: [
  {
    name: address_45proofTKy5HbozVVMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-address-proof___en-US",
    path: address_45proofTKy5HbozVVMeta?.path ?? "address-proof",
    meta: address_45proofTKy5HbozVVMeta || {},
    alias: address_45proofTKy5HbozVVMeta?.alias || [],
    redirect: address_45proofTKy5HbozVVMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/address-proof.vue").then(m => m.default || m)
  },
  {
    name: biometricPbWssqRRsnMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-biometric___en-US",
    path: biometricPbWssqRRsnMeta?.path ?? "biometric",
    meta: biometricPbWssqRRsnMeta || {},
    alias: biometricPbWssqRRsnMeta?.alias || [],
    redirect: biometricPbWssqRRsnMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/biometric.vue").then(m => m.default || m)
  },
  {
    name: digital_45certificateSvrismDTm3Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-digital-certificate___en-US",
    path: digital_45certificateSvrismDTm3Meta?.path ?? "digital-certificate",
    meta: digital_45certificateSvrismDTm3Meta || {},
    alias: digital_45certificateSvrismDTm3Meta?.alias || [],
    redirect: digital_45certificateSvrismDTm3Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/digital-certificate.vue").then(m => m.default || m)
  },
  {
    name: documentscopyM4jA99t3nKMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-documentscopy___en-US",
    path: documentscopyM4jA99t3nKMeta?.path ?? "documentscopy",
    meta: documentscopyM4jA99t3nKMeta || {},
    alias: documentscopyM4jA99t3nKMeta?.alias || [],
    redirect: documentscopyM4jA99t3nKMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/documentscopy.vue").then(m => m.default || m)
  },
  {
    name: facial_45biometricsjmsZdtzTUZMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-facial-biometrics___en-US",
    path: facial_45biometricsjmsZdtzTUZMeta?.path ?? "facial-biometrics",
    meta: facial_45biometricsjmsZdtzTUZMeta || {},
    alias: facial_45biometricsjmsZdtzTUZMeta?.alias || [],
    redirect: facial_45biometricsjmsZdtzTUZMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/facial-biometrics.vue").then(m => m.default || m)
  },
  {
    name: handwrittenmCtvPb5KjfMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-handwritten___en-US",
    path: handwrittenmCtvPb5KjfMeta?.path ?? "handwritten",
    meta: handwrittenmCtvPb5KjfMeta || {},
    alias: handwrittenmCtvPb5KjfMeta?.alias || [],
    redirect: handwrittenmCtvPb5KjfMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/handwritten.vue").then(m => m.default || m)
  },
  {
    name: informationrqAudPo1XGMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-information___en-US",
    path: informationrqAudPo1XGMeta?.path ?? "information",
    meta: informationrqAudPo1XGMeta || {},
    alias: informationrqAudPo1XGMeta?.alias || [],
    redirect: informationrqAudPo1XGMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/information.vue").then(m => m.default || m)
  },
  {
    name: livenessWXWhlNCVDbMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-liveness___en-US",
    path: livenessWXWhlNCVDbMeta?.path ?? "liveness",
    meta: livenessWXWhlNCVDbMeta || {},
    alias: livenessWXWhlNCVDbMeta?.alias || [],
    redirect: livenessWXWhlNCVDbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/liveness.vue").then(m => m.default || m)
  },
  {
    name: official_45doc9yKt4M9RYJMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-official-doc___en-US",
    path: official_45doc9yKt4M9RYJMeta?.path ?? "official-doc",
    meta: official_45doc9yKt4M9RYJMeta || {},
    alias: official_45doc9yKt4M9RYJMeta?.alias || [],
    redirect: official_45doc9yKt4M9RYJMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/official-doc.vue").then(m => m.default || m)
  },
  {
    name: pixUMG7I0U3cFMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-pix___en-US",
    path: pixUMG7I0U3cFMeta?.path ?? "pix",
    meta: pixUMG7I0U3cFMeta || {},
    alias: pixUMG7I0U3cFMeta?.alias || [],
    redirect: pixUMG7I0U3cFMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/pix.vue").then(m => m.default || m)
  },
  {
    name: selfie_45plus_45docf9bVDxjvBeMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-selfie-plus-doc___en-US",
    path: selfie_45plus_45docf9bVDxjvBeMeta?.path ?? "selfie-plus-doc",
    meta: selfie_45plus_45docf9bVDxjvBeMeta || {},
    alias: selfie_45plus_45docf9bVDxjvBeMeta?.alias || [],
    redirect: selfie_45plus_45docf9bVDxjvBeMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/selfie-plus-doc.vue").then(m => m.default || m)
  },
  {
    name: summaryJv1qNkv7nAMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-summary___en-US",
    path: summaryJv1qNkv7nAMeta?.path ?? "summary",
    meta: summaryJv1qNkv7nAMeta || {},
    alias: summaryJv1qNkv7nAMeta?.alias || [],
    redirect: summaryJv1qNkv7nAMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/summary.vue").then(m => m.default || m)
  },
  {
    name: _91tokenKind_93UF12bZifcIMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-token-tokenKind___en-US",
    path: _91tokenKind_93UF12bZifcIMeta?.path ?? "token/:tokenKind()",
    meta: _91tokenKind_93UF12bZifcIMeta || {},
    alias: _91tokenKind_93UF12bZifcIMeta?.alias || [],
    redirect: _91tokenKind_93UF12bZifcIMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/token/[tokenKind].vue").then(m => m.default || m)
  }
],
    meta: requirementVXfrWJ59k6Meta || {},
    alias: requirementVXfrWJ59k6Meta?.alias || [],
    redirect: requirementVXfrWJ59k6Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement.vue").then(m => m.default || m)
  },
  {
    name: requirementVXfrWJ59k6Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement___es-MX",
    path: requirementVXfrWJ59k6Meta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/requirement",
    children: [
  {
    name: address_45proofTKy5HbozVVMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-address-proof___es-MX",
    path: address_45proofTKy5HbozVVMeta?.path ?? "address-proof",
    meta: address_45proofTKy5HbozVVMeta || {},
    alias: address_45proofTKy5HbozVVMeta?.alias || [],
    redirect: address_45proofTKy5HbozVVMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/address-proof.vue").then(m => m.default || m)
  },
  {
    name: biometricPbWssqRRsnMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-biometric___es-MX",
    path: biometricPbWssqRRsnMeta?.path ?? "biometric",
    meta: biometricPbWssqRRsnMeta || {},
    alias: biometricPbWssqRRsnMeta?.alias || [],
    redirect: biometricPbWssqRRsnMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/biometric.vue").then(m => m.default || m)
  },
  {
    name: digital_45certificateSvrismDTm3Meta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-digital-certificate___es-MX",
    path: digital_45certificateSvrismDTm3Meta?.path ?? "digital-certificate",
    meta: digital_45certificateSvrismDTm3Meta || {},
    alias: digital_45certificateSvrismDTm3Meta?.alias || [],
    redirect: digital_45certificateSvrismDTm3Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/digital-certificate.vue").then(m => m.default || m)
  },
  {
    name: documentscopyM4jA99t3nKMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-documentscopy___es-MX",
    path: documentscopyM4jA99t3nKMeta?.path ?? "documentscopy",
    meta: documentscopyM4jA99t3nKMeta || {},
    alias: documentscopyM4jA99t3nKMeta?.alias || [],
    redirect: documentscopyM4jA99t3nKMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/documentscopy.vue").then(m => m.default || m)
  },
  {
    name: facial_45biometricsjmsZdtzTUZMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-facial-biometrics___es-MX",
    path: facial_45biometricsjmsZdtzTUZMeta?.path ?? "facial-biometrics",
    meta: facial_45biometricsjmsZdtzTUZMeta || {},
    alias: facial_45biometricsjmsZdtzTUZMeta?.alias || [],
    redirect: facial_45biometricsjmsZdtzTUZMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/facial-biometrics.vue").then(m => m.default || m)
  },
  {
    name: handwrittenmCtvPb5KjfMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-handwritten___es-MX",
    path: handwrittenmCtvPb5KjfMeta?.path ?? "handwritten",
    meta: handwrittenmCtvPb5KjfMeta || {},
    alias: handwrittenmCtvPb5KjfMeta?.alias || [],
    redirect: handwrittenmCtvPb5KjfMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/handwritten.vue").then(m => m.default || m)
  },
  {
    name: informationrqAudPo1XGMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-information___es-MX",
    path: informationrqAudPo1XGMeta?.path ?? "information",
    meta: informationrqAudPo1XGMeta || {},
    alias: informationrqAudPo1XGMeta?.alias || [],
    redirect: informationrqAudPo1XGMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/information.vue").then(m => m.default || m)
  },
  {
    name: livenessWXWhlNCVDbMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-liveness___es-MX",
    path: livenessWXWhlNCVDbMeta?.path ?? "liveness",
    meta: livenessWXWhlNCVDbMeta || {},
    alias: livenessWXWhlNCVDbMeta?.alias || [],
    redirect: livenessWXWhlNCVDbMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/liveness.vue").then(m => m.default || m)
  },
  {
    name: official_45doc9yKt4M9RYJMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-official-doc___es-MX",
    path: official_45doc9yKt4M9RYJMeta?.path ?? "official-doc",
    meta: official_45doc9yKt4M9RYJMeta || {},
    alias: official_45doc9yKt4M9RYJMeta?.alias || [],
    redirect: official_45doc9yKt4M9RYJMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/official-doc.vue").then(m => m.default || m)
  },
  {
    name: pixUMG7I0U3cFMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-pix___es-MX",
    path: pixUMG7I0U3cFMeta?.path ?? "pix",
    meta: pixUMG7I0U3cFMeta || {},
    alias: pixUMG7I0U3cFMeta?.alias || [],
    redirect: pixUMG7I0U3cFMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/pix.vue").then(m => m.default || m)
  },
  {
    name: selfie_45plus_45docf9bVDxjvBeMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-selfie-plus-doc___es-MX",
    path: selfie_45plus_45docf9bVDxjvBeMeta?.path ?? "selfie-plus-doc",
    meta: selfie_45plus_45docf9bVDxjvBeMeta || {},
    alias: selfie_45plus_45docf9bVDxjvBeMeta?.alias || [],
    redirect: selfie_45plus_45docf9bVDxjvBeMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/selfie-plus-doc.vue").then(m => m.default || m)
  },
  {
    name: summaryJv1qNkv7nAMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-summary___es-MX",
    path: summaryJv1qNkv7nAMeta?.path ?? "summary",
    meta: summaryJv1qNkv7nAMeta || {},
    alias: summaryJv1qNkv7nAMeta?.alias || [],
    redirect: summaryJv1qNkv7nAMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/summary.vue").then(m => m.default || m)
  },
  {
    name: _91tokenKind_93UF12bZifcIMeta?.name ?? "signatureRequestKind-signatureRequestKey-requirement-token-tokenKind___es-MX",
    path: _91tokenKind_93UF12bZifcIMeta?.path ?? "token/:tokenKind()",
    meta: _91tokenKind_93UF12bZifcIMeta || {},
    alias: _91tokenKind_93UF12bZifcIMeta?.alias || [],
    redirect: _91tokenKind_93UF12bZifcIMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement/token/[tokenKind].vue").then(m => m.default || m)
  }
],
    meta: requirementVXfrWJ59k6Meta || {},
    alias: requirementVXfrWJ59k6Meta?.alias || [],
    redirect: requirementVXfrWJ59k6Meta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/requirement/pages/[signatureRequestKind]/[signatureRequestKey]/requirement.vue").then(m => m.default || m)
  },
  {
    name: agreementsaN6rRVESCiMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey-agreements___pt-BR___default",
    path: agreementsaN6rRVESCiMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()/agreements",
    meta: agreementsaN6rRVESCiMeta || {},
    alias: agreementsaN6rRVESCiMeta?.alias || [],
    redirect: agreementsaN6rRVESCiMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/agreements.vue").then(m => m.default || m)
  },
  {
    name: agreementsaN6rRVESCiMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey-agreements___pt-BR",
    path: agreementsaN6rRVESCiMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()/agreements",
    meta: agreementsaN6rRVESCiMeta || {},
    alias: agreementsaN6rRVESCiMeta?.alias || [],
    redirect: agreementsaN6rRVESCiMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/agreements.vue").then(m => m.default || m)
  },
  {
    name: agreementsaN6rRVESCiMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey-agreements___en-US",
    path: agreementsaN6rRVESCiMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()/agreements",
    meta: agreementsaN6rRVESCiMeta || {},
    alias: agreementsaN6rRVESCiMeta?.alias || [],
    redirect: agreementsaN6rRVESCiMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/agreements.vue").then(m => m.default || m)
  },
  {
    name: agreementsaN6rRVESCiMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey-agreements___es-MX",
    path: agreementsaN6rRVESCiMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()/agreements",
    meta: agreementsaN6rRVESCiMeta || {},
    alias: agreementsaN6rRVESCiMeta?.alias || [],
    redirect: agreementsaN6rRVESCiMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/agreements.vue").then(m => m.default || m)
  },
  {
    name: indexgycyvmJmtYMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey___pt-BR___default",
    path: indexgycyvmJmtYMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()",
    meta: indexgycyvmJmtYMeta || {},
    alias: indexgycyvmJmtYMeta?.alias || [],
    redirect: indexgycyvmJmtYMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/index.vue").then(m => m.default || m)
  },
  {
    name: indexgycyvmJmtYMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey___pt-BR",
    path: indexgycyvmJmtYMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()",
    meta: indexgycyvmJmtYMeta || {},
    alias: indexgycyvmJmtYMeta?.alias || [],
    redirect: indexgycyvmJmtYMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/index.vue").then(m => m.default || m)
  },
  {
    name: indexgycyvmJmtYMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey___en-US",
    path: indexgycyvmJmtYMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()",
    meta: indexgycyvmJmtYMeta || {},
    alias: indexgycyvmJmtYMeta?.alias || [],
    redirect: indexgycyvmJmtYMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/index.vue").then(m => m.default || m)
  },
  {
    name: indexgycyvmJmtYMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents-documentKey___es-MX",
    path: indexgycyvmJmtYMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/documents/:documentKey()",
    meta: indexgycyvmJmtYMeta || {},
    alias: indexgycyvmJmtYMeta?.alias || [],
    redirect: indexgycyvmJmtYMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/[documentKey]/index.vue").then(m => m.default || m)
  },
  {
    name: indexSEnKvuPz4GMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents___pt-BR___default",
    path: indexSEnKvuPz4GMeta?.path ?? "/:signatureRequestKind()/:signatureRequestKey()/documents",
    meta: indexSEnKvuPz4GMeta || {},
    alias: indexSEnKvuPz4GMeta?.alias || [],
    redirect: indexSEnKvuPz4GMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexSEnKvuPz4GMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents___pt-BR",
    path: indexSEnKvuPz4GMeta?.path ?? "/pt-BR/:signatureRequestKind()/:signatureRequestKey()/documents",
    meta: indexSEnKvuPz4GMeta || {},
    alias: indexSEnKvuPz4GMeta?.alias || [],
    redirect: indexSEnKvuPz4GMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexSEnKvuPz4GMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents___en-US",
    path: indexSEnKvuPz4GMeta?.path ?? "/en-US/:signatureRequestKind()/:signatureRequestKey()/documents",
    meta: indexSEnKvuPz4GMeta || {},
    alias: indexSEnKvuPz4GMeta?.alias || [],
    redirect: indexSEnKvuPz4GMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexSEnKvuPz4GMeta?.name ?? "signatureRequestKind-signatureRequestKey-documents___es-MX",
    path: indexSEnKvuPz4GMeta?.path ?? "/es-MX/:signatureRequestKind()/:signatureRequestKey()/documents",
    meta: indexSEnKvuPz4GMeta || {},
    alias: indexSEnKvuPz4GMeta?.alias || [],
    redirect: indexSEnKvuPz4GMeta?.redirect || undefined,
    component: () => import("/runner/_work/nova-widget/nova-widget/domains/document/pages/[signatureRequestKind]/[signatureRequestKey]/documents/index.vue").then(m => m.default || m)
  }
]